/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AgentDashboardVisitsResponse,
} from '../models/index';
import {
    AgentDashboardVisitsResponseFromJSON,
    AgentDashboardVisitsResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class AgentDashboardApi extends runtime.BaseAPI {

    /**
     * Get visits with open forms assigned to the authenticated agent (task queue).
     * Get Agent Visits
     */
    async getAgentVisitsApiV1PublicAgentVisitsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AgentDashboardVisitsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/public/agent/visits`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AgentDashboardVisitsResponseFromJSON(jsonValue));
    }

    /**
     * Get visits with open forms assigned to the authenticated agent (task queue).
     * Get Agent Visits
     */
    async getAgentVisitsApiV1PublicAgentVisitsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AgentDashboardVisitsResponse> {
        const response = await this.getAgentVisitsApiV1PublicAgentVisitsGetRaw(initOverrides);
        return await response.value();
    }

}
